<script setup lang="ts">
import type { NavigationLinkFragment } from '#graphql-operations'

interface HeaderNavLinkProps {
  link?: NavigationLinkFragment
}

defineProps<HeaderNavLinkProps>()
</script>

<template>
  <li class="headerNavLink inline-flex relative z-2">
    <ButtonNav :link />
  </li>
</template>
